import type { FaireProductEntity } from "../../entity_types/product";

export const p_ws3uqsb7qv: FaireProductEntity = {
  token: "p_ws3uqsb7qv",
  type: "product",
  name: "Sleep Support Oral Supplement/Vitamin",
  brandToken: "b_daeyv9q8xk",
  brandName: "Nutra Moment",
  imageUrl:
    "https://cdn.faire.com/fastly/98a3d7a6c95cdfa55c715a58124cf00dcb404b2994b2bac74b77cfbf3804672f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2489ab4880614ae08cf24c56c6774b755ba176324270316b7423042ba18c3452.jpeg",
    "https://cdn.faire.com/fastly/3d018fcaafc8d78ca8329a3ae687efe0efe17312d3c7e4391a10d785dc80f342.jpeg",
    "https://cdn.faire.com/fastly/e048defe8864e7dd28641c28a10b9d816ec69b4bff794c99fa1cd0f912440fc3.jpeg",
  ],
  priceDollars: 11.99,
  description:
    "\n\n\n \n\n Worried about getting enough sleep?\n\n\nThe Sleep Support  Formula from Nutramoment is designed to help you fall asleep faster, remain asleep longer, and wake up feeling rested and energized. Melatonin and chamomile are among the natural substances used in their formulation to provide a peaceful night's sleep.†\n\nSleep support by Nutra Moment can help you sleep better. This supplement is ideal for helping those exhausted or need a little additional support in sleeping. The neurological system is stimulated, and the body is relaxed due to the sleep support formula's actions. Using natural components like Passion Flower and Skullcap, sleep support has been proven to help improve general health and well-being.",
  tags: [],
  msrpDollars: 23.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:04.746Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
